import { LeadQuestion } from '@app/core/model/qualifications.model';

export interface AccidentDetail {
  accidentType: string;
  date: Date;
  location: string;
}

export interface DailyCommitmentResponse {
  date: Date;
  driverDailyLeadId: number;
  response: string;
}

export class CommitmentResponses {
  psFormReply: DailyFormResponse;
  leadId: number;
  tractor: string;
  responses: CommitmentResponseData[];
  driverDailyLeadId: number;
  date: string;
  driverCode: string;

  public toJSON() {
    return {
      psFormReply: this.psFormReply,
      leadId: this.leadId,
      tractor: this.tractor,
      responses: this.responses,
      driverDailyLeadId: this.driverDailyLeadId,
      date: this.date,
      driverCode: this.driverCode,
    };
  }
}

export interface CommitmentResponseData {
  question: string;
  questionType: string;
  questionAnswer: string;
}

export interface DailyFormResponse {
  answer: string;
  driverId: string;
  dutyDate: Date;
  formId: string;
}

export interface DailyCommitmentQuestion {
  driverDailyLeadId: number;
  leadId: number;
  questions: LeadQuestion[];
}
